<template>
  <div class="" style="margin-bottom: 50px">
    <div class="accordion" id="einzel_accordionExample">
      <div class="d-none d-sm-block">
        <div class="steps">
          <progress
            id="progress"
            :value="[step == 1 ? '25' : [step == 2 ? '75' : '100']]"
            max="100"
          ></progress>
          <div class="step-item">
            <button
              class="step-button text-center"
              type="button"
              aria-expanded="true"
            >
              1
            </button>
            <div class="step-title">scannen</div>
          </div>
          <div class="step-item">
            <button
              class="step-button text-center"
              :class="[step > 1 ? '' : 'collapsed']"
              type="button"
              :aria-expanded="[step > 1 ? 'true' : 'false']"
            >
              2
            </button>
            <div class="step-title">prüfen</div>
          </div>
          <div class="step-item">
            <button
              class="step-button text-center"
              :class="[step > 2 ? '' : 'collapsed']"
              type="button"
              :aria-expanded="[step > 2 ? 'true' : 'false']"
            >
              3
            </button>
            <div class="step-title">Startnr</div>
          </div>
        </div>
      </div>

      <div style="display: none">{{ scanncode }}</div>
      <div class="card1" v-if="produktdaten.status == 0">
        <div
          id="collapseOne"
          class="collapse show"
          aria-labelledby="headingOne"
          data-bs-parent="#einzel_accordionExample"
        >
          <div class="card-body" style="padding: 0">
            <div class="card">
              <div class="card-header">
                {{ produktdaten.name }}
              </div>
              <div>
                <div class="card-body">
                  Aktueller Bestand:
                  {{ nummerFormatieren(produktdaten.bestandgesamt) }}
                  {{ produktdaten.stueckname }}
                </div>
                <div>
                  <div>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id=""
                          >{{ produktdaten.einheitenname }} ({{
                            nummerFormatieren(stueckproeinheit)
                          }})</span
                        >
                      </div>
                      <input
                        type="number"
                        v-model="einheitenanzahl"
                        class="form-control input-zahlen"
                        @input="UpdateEinheit()"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-success"
                          type="button"
                          v-on:click="EinheitAdd()"
                        >
                          plus
                        </button>
                        <button
                          class="btn btn-danger"
                          type="button"
                          v-on:click="EinheitMinus()"
                        >
                          minus
                        </button>
                      </div>
                    </div>

                    <br />

                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id=""
                          >{{ produktdaten.palettenname }} ({{
                            stueckpropalette
                          }})</span
                        >
                      </div>
                      <input
                        type="number"
                        v-model="palettenanzahl"
                        class="form-control input-zahlen"
                        @input="UpdatePaletten()"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-success"
                          type="button"
                          v-on:click="PalettenAdd()"
                        >
                          plus
                        </button>
                        <button
                          class="btn btn-danger"
                          type="button"
                          v-on:click="PalettenMinus()"
                        >
                          minus
                        </button>
                      </div>
                    </div>

                    <br />

                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="">{{
                          produktdaten.stueckname
                        }}</span>
                      </div>
                      <input
                        type="number"
                        v-model="stueckanzahl"
                        class="form-control input-zahlen"
                        @input="UpdateStueck()"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-success"
                          type="button"
                          v-on:click="StueckAdd()"
                        >
                          plus
                        </button>
                        <button
                          class="btn btn-danger"
                          type="button"
                          v-on:click="StueckMinus()"
                        >
                          minus
                        </button>
                      </div>
                    </div>

                    <br />
                    <div class="card-body">
                      <button
                        type="button"
                        class="btn btn-outline-success"
                        v-on:click="ListeAdd()"
                        v-if="bestellenwasinfo"
                      >
                        {{ bestellenwasinfo }} hinzufügen
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card1" v-if="step == '1' && produktdaten.status != 0">
        <div
          id="collapseOne"
          class="collapse show"
          aria-labelledby="headingOne"
          data-bs-parent="#einzel_accordionExample"
        >
          <div class="card-body" style="padding: 0">
            <div class="card">
              <div class="card-header" v-if="!input">
                Scanne den Paletten-QR-Code...
              </div>
              <div class="card-body">
                <div class="d-flex justify-content-around">
                  <div class="col-12 col-md-11">
                    <Form
                      @submit="submitData"
                      :validation-schema="schema"
                      v-slot="{ errors }"
                      v-if="!success"
                    >
                      <div class="input-group mb-3">
                        <span class="input-group-text" id="basic-addon1">
                          <font-awesome-icon
                            :icon="['fas', 'barcode']"
                            size="2xl"
                            v-if="!isLoading"
                          />

                          <font-awesome-icon
                            :icon="['fas', 'star-of-life']"
                            size="2xl"
                            spin
                            v-if="isLoading"
                          />
                        </span>
                        <Field
                          as="input"
                          name="barcode"
                          type="text"
                          class="form-control"
                          id="barcode"
                          ref="barcode"
                          autocomplete="given-name"
                          placeholder="QR-Code"
                          aria-label="QR-Code"
                          aria-describedby="basic-addon1"
                        />
                      </div>
                      <small class="text-danger" v-if="errors.barcode">{{
                        errors.barcode
                      }}</small>

                      <div v-if="input != ''">
                        <div class="list-group">
                          <a
                            v-for="eintrag in suchenliste"
                            :key="eintrag.bib"
                            href="#"
                            @click="setBarcode(eintrag.bib)"
                            class="list-group-item list-group-item-action d-flex justify-content-between align-items-start px-0"
                          >
                            <div class="container">
                              <div class="row">
                                <div class="col px-2">
                                  <span class="fw-bold">
                                    {{ eintrag.name }}
                                  </span>
                                  <span
                                    class="badge bg-success"
                                    style="float: right"
                                    >{{
                                      eintrag.sbib == ""
                                        ? eintrag.bib
                                        : eintrag.sbib
                                    }}</span
                                  >
                                </div>
                              </div>
                              <div class="row">
                                <div class="col p-0 ps-2">
                                  {{ eintrag.contest }}
                                </div>
                                <div class="col text-right p-0 pe-2"></div>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>

                <div v-if="input == ''">
                  <div class="m-1">
                    <h6 class="card-title">Logistik</h6>
                  </div>
                </div>

                <div v-if="input == ''">
                  <div class="card m-1 bg-success-logistik text-white">
                    <div class="card-body py-2">
                      <a class="stretched-link"></a>
                      <h6 class="card-title">Logistik</h6>
                      <h4 class="card-text">Pickliste</h4>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-center">
                  <img
                    v-if="input == ''"
                    class="logo my-3"
                    style="width: 96%; max-width: 130px"
                    src="@/assets/img/Baho_Markenzeichen.svg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <nav class="navbar fixed-bottom navbar-light bg-light justify-content-end">
    <div class="col-12 col-lg-9">
      <div class="d-flex justify-content-around">
        <b-button @click="step--" :disabled="step < 2" style="width: 110px"
          ><font-awesome-icon :icon="['fass', 'forward']" rotation="180" />
          zurück</b-button
        >
        <b-button
          variant="danger"
          v-on:click="abbrechenZeigen()"
          style="width: 110px"
          >abbrechen</b-button
        >
        <b-button
          variant="success"
          @click="step++"
          :disabled="true"
          style="width: 110px"
          >weiter <font-awesome-icon :icon="['fass', 'forward']"
        /></b-button>
      </div>
    </div>
  </nav>
</template>

<script>
//import { mapGetters } from "vuex";
import Store from "@/store";
import { Form, Field } from "vee-validate";
import * as yup from "yup";
import { uuid } from "vue-uuid";
import axios from "axios";
//import dayjs from "dayjs";
//import { useSound } from "@vueuse/sound";
//import soundError from "@/assets/sounds/error.mp3";

//import { log } from "logrocket";
import { useToast } from "vue-toastification";

export default {
  name: "TheLogistikListe",
  components: {
    Form,
    Field,
    //...mapGetters({ cartSum: "cartTotal" }), // wenn auf andere Variable übergeben wird
  },
  data() {
    const schema = yup.object().shape({
      barcode: yup
        .string()
        .required("Ein Barcode/Name wird benötigt.")
        .trim()
        .min(3, "Der Barcode/Name muss >3 Zeichen lang sein!"),
    });
    return {
      step: 1,
      schema,
      error: "",
      isLoading: false,
      success: false,

      invitee: "",
      mode: "",
      input: "",
      suchenliste: [],

      produktdaten: [],

      einheitenanzahl: 0,
      palettenanzahl: 0,
      stueckanzahl: 0,
      stueckproeinheit: 0,
      stueckpropalette: 0,
      bestellenwas: false,
      bestellenstueck: false,
      bestellenwasinfo: false,
      produktid: 0,

      toast: useToast(),
    };
  },
  props: {
    search: {
      type: String,
      default: "",
    },
  },
  computed: {
    rrID() {
      return Store.getters.activeRREvent();
    },

    searchData() {
      return this.search;
    },
    scanncode() {
      console.log("scanncodeaufruf....");
      var scanncode_akt = Store.getters.activeBarcode();
      Store.mutations.setBarcode([]);
      if (scanncode_akt.org) {
        // Manuelle Sucheliste leeren
        this.suchlisteLeeren();
        console.log("GP scanncode aufruf!", scanncode_akt, this.step);
        if (this.step == 1) {
          if (scanncode_akt.type == "#") {
            this.setBarcode(scanncode_akt.gsplit);

            //Store.mutations.setBarcode([]);
            scanncode_akt = [];
          } else {
            // Barcode falsch
            this.toast.error("Barcode an dieser Stelle nicht möglich!");
            //Store.mutations.setBarcode([]);
            scanncode_akt = [];
          }
        }
      }
      return scanncode_akt;
    },
  },

  methods: {
    UpdateEinheit() {
      console.log("update Einheit", this.einheitenanzahl);
      this.stueckanzahl = this.einheitenanzahl * this.stueckproeinheit;
      this.bestellenwas = "einheit";
      this.bestellenstueck = this.einheitenanzahl;
      this.bestellenwasinfo = this.einheitenanzahl + " " + this.einheitenname;

      this.palettenanzahl = Math.floor(
        this.stueckanzahl / this.stueckproeinheit / this.stueckpropalette
      );
    },

    EinheitAdd() {
      if (!isNaN(this.einheitenanzahl)) {
        this.einheitenanzahl = this.einheitenanzahl + 1;

        this.UpdateEinheit();
      } else {
        this.einheitenanzahl = 0;
        this.UpdateEinheit();
      }
    },

    EinheitMinus() {
      if (!isNaN(this.einheitenanzahl)) {
        if (this.einheitenanzahl > 0) {
          this.einheitenanzahl = this.einheitenanzahl - 1;

          this.UpdateEinheit();
        }
      } else {
        this.einheitenanzahl = 0;

        this.UpdateEinheit();
      }
    },
    EinheitCheck() {
      console.log(this.einheitenanzahl);
      //this.einheitenanzahl= this.einheitenanzahl - 1;
    },

    UpdatePaletten() {
      console.log("update Paletten ", this.palettenanzahl);

      this.stueckanzahl =
        this.palettenanzahl * (this.stueckproeinheit * this.stueckpropalette);
      this.bestellenwas = "palette";
      this.bestellenstueck = this.palettenanzahl;
      this.bestellenwasinfo = this.palettenanzahl + " " + this.palettenname;

      this.einheitenanzahl = this.stueckanzahl / this.stueckproeinheit;
    },

    PalettenAdd() {
      if (!isNaN(this.palettenanzahl)) {
        this.palettenanzahl = this.palettenanzahl + 1;

        this.UpdatePaletten();
      } else {
        this.palettenanzahl = 0;

        this.UpdatePaletten();
      }
    },

    PalettenMinus() {
      if (!isNaN(this.palettenanzahl)) {
        if (this.palettenanzahl > 0) {
          this.palettenanzahl = this.palettenanzahl - 1;
          this.UpdatePaletten();
        }
      } else {
        this.palettenanzahl = 0;

        this.UpdatePaletten();
      }
    },

    PalettenCheck() {
      console.log(this.palettenanzahl);
      //this.einheitenanzahl= this.einheitenanzahl - 1;
    },

    UpdateStueck() {
      console.log("update Stück ", this.stueckanzahl);
      this.palettenanzahl = Math.floor(
        this.stueckanzahl / this.stueckproeinheit / this.stueckpropalette
      );
      this.bestellenwas = "stueck";
      this.bestellenstueck = this.stueckanzahl;
      this.bestellenwasinfo = this.stueckanzahl + "  Stück";

      this.einheitenanzahl = Math.floor(
        this.stueckanzahl / this.stueckproeinheit
      );
    },

    StueckAdd() {
      if (!isNaN(this.stueckanzahl)) {
        this.stueckanzahl = this.stueckanzahl + 1;

        this.UpdateStueck();
      } else {
        this.stueckanzahl = 0;

        this.UpdateStueck();
      }
    },

    StueckMinus() {
      if (!isNaN(this.stueckanzahl)) {
        if (this.stueckanzahl > 0) {
          this.stueckanzahl = this.stueckanzahl - 1;

          this.UpdateStueck();
        }
      } else {
        this.stueckanzahl = 0;

        this.UpdateStueck();
      }
    },

    StueckCheck() {
      console.log(this.einheitenanzahl);
      //this.einheitenanzahl= this.einheitenanzahl - 1;
    },

    ListeAdd() {
      console.log("ListeAdd", Store.getters.activeGeraet());

      this.isGescannt = true;
      this.isLoading = true;

      axios
        .get(
          "https://bahnhof-logistik.pani-verwaltung.de/module/api_logistik.php?produktid=" +
            this.produktid +
            "&was=" +
            this.bestellenwas +
            "&stueck=" +
            this.bestellenstueck +
            "&user=" +
            Store.getters.activeGeraet() +
            "&uuid=" +
            uuid.v1()
        )
        .then((response) => {
          console.log(response.data);
          this.isGescannt = false;
          this.isLoading = false;
          this.result = response.data + " weiteres Produkt scannen...";
          this.einheitenanzahl = 0;
          this.palettenanzahl = 0;
          this.stueckanzahl = 0;
          this.stueckproeinheit = 0;
          this.stueckpropalette = 0;
          this.bestellenwas = false;
          this.bestellenstueck = false;
          this.bestellenwasinfo = false;
          this.produktid = 0;
          this.produktdaten = [];

          return false;
        })
        .catch((error) => {
          this.isLoading = false;
          throw new Error(error);
        });
    },

    nummerFormatieren(x, stellen = 0) {
      return Number.parseFloat(x).toFixed(stellen);
    },
    holeProduktInfo(nr) {
      axios
        .get(
          "https://bahnhof-logistik.pani-verwaltung.de/module/api_logistik.php" +
            "?nr=" +
            nr +
            "&user=" +
            Store.getters.activeGeraet() +
            "&uuid=" +
            uuid.v1()
        )
        .then((response) => {
          console.log(response.data.status);

          this.isLoading = false;

          if (response.data.status == "0") {
            console.log("fertig geholt...");
            this.produktdaten = response.data;

            //Stueck in Stück ersetzen
            this.produktdaten.einheitenname =
              this.produktdaten.einheitenname.replace("Stueck", "Stück");
            this.produktdaten.stueckname = this.produktdaten.stueckname.replace(
              "Stueck",
              "Stück"
            );

            //this.einheitenanzahl = 0;

            //this.stueckanzahl = this.einheitenanzahl * this.stueckproeinheit;
            //this.bestellenwas = "einheit";
            //this.produktdaten.bestellenstueck = this.einheitenanzahl;

            //this.bestellenwasinfo = this.einheitenanzahl + " " + this.produktdaten.einheitenname;

            this.stueckname = this.produktdaten.stueckname;
            this.einheitenname = this.produktdaten.einheitenname;
            this.palettenname = this.produktdaten.palettenname;
            this.stueckproeinheit = parseInt(
              this.produktdaten.stueckproeinheit
            );
            this.stueckpropalette = parseInt(
              this.produktdaten.stueckpropalette
            );
            this.produktid = parseInt(this.produktdaten.id);

            console.log("Response Data", response.data);
            console.log("Prdouktdaten", this.produktdaten);
          }
          return false;
        })
        .catch((error) => {
          this.isLoading = false;
          throw new Error(error);
        });
    },

    suchlisteLeeren() {
      // Manuelle Sucheliste leeren
      console.log("suchlisteLeeren");
      this.input = "";
      this.suchenliste = [];
    },

    submitData(values) {
      this.isLoading = true;
      this.success = false;
      this.error = "";
      console.log(values);
      this.input = values.barcode;
      //this.invitee = uuid.v1();
      //this.holePersonen();
    },
    focusInput() {
      if (this.searchData) {
        this.$refs.barcode.$el.value = this.searchData;
        this.input = this.searchData;
        //this.holePersonen();
      } else {
        this.$refs.barcode.$el.focus();
      }
    },
    modusUpdate(event) {
      console.log(event);
      this.$emit("modus-updated", event);
      this.mode = event;
    },
    setBarcode(id) {
      //if (check) {
      this.barcode = id;
      console.log("setBarcode ", this.barcode);
      this.holeProduktInfo(id);
      //this.holePerson();
      //this.step = 2;
      //} else {
      //  console.log(check);
      //}
    },
    abbrechenZeigen() {
      //if (this.sammelTLNs.length > 0) {
      //  this.listeAbbrechen = true;
      window.scrollTo(0, 0);
      //} else {
      if (this.step > 1) {
        this.step--;
        console.log("abbrechenZeigen step--");
        //Store.mutations.deleteAlleSammelTLNs();
      } else if (this.step > 0) {
        this.modusUpdate({ newModus: "0" });
      }

      //}
    },
  },
  emits: {
    "modus-updated": (modusDO) => {
      if ("newModus" in modusDO === false) {
        console.warn(
          "ModusCardComponent: Jede Button muss ein Modus-Attribut haben."
        );
        return false;
      }
      return true;
    },
  },
  mounted() {
    //this.focusInput();
  },
};
</script>

<style scoped>
.bg-success-logistik {
  background-color: rgba(45 104 48);
}
.input-zahlen {
  text-align: center;
  font-weight: bold;
}
</style>
